import React, { useState, useEffect } from 'react';

interface Committee {
  id: number;
  name: string;
}

interface SearchAndFilterProps {
  onSearch: (query: string) => void;
  onFilterChange: (filter: string) => void;
  onCommitteeFilterChange?: (committeeId: number | undefined) => void;
  onSearchAttachmentsChange?: (enabled: boolean) => void;
  committees?: Committee[];
  selectedCommittee?: number;
  searchAttachments?: boolean;
}

const SearchAndFilter: React.FC<SearchAndFilterProps> = ({
  onSearch,
  onFilterChange,
  onCommitteeFilterChange,
  onSearchAttachmentsChange,
  committees = [],
  selectedCommittee,
  searchAttachments = false
}) => {
  const [searchInput, setSearchInput] = useState('');

  // Debounce search input
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      onSearch(searchInput);
    }, 300);
    return () => clearTimeout(timeoutId);
  }, [searchInput, onSearch]);

  return (
    <div className="mb-8 space-y-4">
      <div className="flex flex-col md:flex-row gap-4">
        <div className="flex-1">
          <input
            type="text"
            placeholder="Search meetings by agenda items, bill numbers, topics..."
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-nyc-blue focus:border-transparent"
            value={searchInput}
            onChange={(e) => setSearchInput(e.target.value)}
          />
          {onSearchAttachmentsChange && (
            <label className="inline-flex items-center mt-2 text-sm text-gray-600 cursor-pointer">
              <input
                type="checkbox"
                checked={searchAttachments}
                onChange={(e) => onSearchAttachmentsChange(e.target.checked)}
                className="mr-2 rounded border-gray-300 text-nyc-blue focus:ring-nyc-blue"
              />
              Also search within attached documents
            </label>
          )}
        </div>
        {committees.length > 0 && (
          <div className="w-full md:w-64">
            <select
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-nyc-blue focus:border-transparent"
              value={selectedCommittee || ''}
              onChange={(e) => onCommitteeFilterChange?.(e.target.value ? Number(e.target.value) : undefined)}
            >
              <option value="">All Committees</option>
              {committees.map((committee) => (
                <option key={committee.id} value={committee.id}>
                  {committee.name}
                </option>
              ))}
            </select>
          </div>
        )}
        <div className="w-full md:w-64">
          <select
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-nyc-blue focus:border-transparent"
            onChange={(e) => onFilterChange(e.target.value)}
          >
            <option value="">All Meetings</option>
            <option value="upcoming">Upcoming Meetings</option>
            <option value="past">Past Meetings</option>
            <option value="thisMonth">This Month</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default SearchAndFilter;
